export enum AssessmentType {
    PRELIMINARY_ASSESSMENT = 'preliminaryAssessment',
    REGULAR_ASSESSMENT = 'regularAssessment',
    TEST_ASSESSMENT = 'testAssessment',
}
